import { executeMutation, executeQuery } from "utils/services/apiServices";
import { showSnackbar } from "utils/snack_bar/store/action";
import { actionTypes, EmailLogProps, MailInput } from "./actionType";
import { MembershipPlansProps } from "modules/membership_plan/commercial_membership_plan/commercial_membership/store/actionType";
import { FETCH_EMAIL_LOGS } from "../graphql/query";
import { SEND_MAIL } from "../graphql/mutation";

// fetch membership duration
export const fetchEmailLogsRequest = () => ({
  type: actionTypes.FETCH_EMAIL_LOGS_REQUEST,
});

export const fetchEmailLogsSuccess = (payload: EmailLogProps[]) => ({
  type: actionTypes.FETCH_EMAIL_LOGS_SUCCESS,
  payload,
});

export const fetchEmailLogsFail = (payload: string) => ({
  type: actionTypes.FETCH_EMAIL_LOGS_FAIL,
  payload,
});

export const fetchEmailLogs = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchEmailLogsRequest());
      const response = await executeQuery(FETCH_EMAIL_LOGS);
      const jsonData = response.data?.fetchEmailLog;
      if (jsonData?.error === null) {
        dispatch(fetchEmailLogsSuccess(jsonData?.data.email_log));
      } else {
        dispatch(fetchEmailLogsFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchEmailLogsFail("Failed to fetch email log(s)"));
    }
  };
};

// create membership duration
export const sendMailRequest = () => ({
  type: actionTypes.SEND_EMAIL_REQUEST,
});

export const sendMailSuccess = (payload: string) => ({
  type: actionTypes.SEND_EMAIL_SUCCESS,
  payload,
});

export const sendMailFail = (payload: string) => ({
  type: actionTypes.SEND_EMAIL_FAIL,
  payload,
});

export const sendMail = (sendMailInput: MailInput) => {
  return async (dispatch: any) => {
    try {
      dispatch(sendMailRequest());
      const inputData = {
        input: sendMailInput,
      };
      const response = await executeMutation(SEND_MAIL, inputData);
      const jsonData = response.data?.sendMail;
      if (jsonData?.error === null) {
        dispatch(sendMailSuccess(jsonData.data.message));
        dispatch(showSnackbar("Success! Package created."));
      } else {
        dispatch(sendMailFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(sendMailFail("Something went wrong, Try again later"));
    }
  };
};

//RESET
export const ResetEMAIL = () => ({
  type: actionTypes.RESET_EMAIL,
});

export const resetEmail = () => {
  return async (dispatch: any) => {
    dispatch(ResetEMAIL());
  };
};
